import { Alert } from 'src/app/shared/class/Alert';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';

import { UserService } from './../../user.service';
import { globalConst } from 'src/app/shared/helpers/constants';
import { Helper } from 'src/app/shared/helpers/helper';

@Component({
  selector: 'app-user-password',
  templateUrl: './user-password.component.html',
  styleUrls: ['./user-password.component.scss']
})
export class UserPasswordComponent implements OnInit {
  public queryParams: any = {};
  public goback = '';
  public passwordForm: FormGroup;
  public hidePassword = true;
  public hideConfirmPassword = true;

  private subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => this.queryParams = params);
    if (!this.queryParams.id) {
      this.router.navigate(['/user/list']);
    }
    this.goback = '';
    this.passwordForm = this.fb.group({
      password: this.fb.control('', [Validators.required, Validators.minLength(6)]),
      confirmPassword: this.fb.control('', [Validators.required, Validators.minLength(6)])
    }, { validator: this.checkPassword });
  }

  checkPassword(group: FormGroup) {
    const password = group.controls.password.value;
    const confirmPassword = group.controls.confirmPassword.value;

    if (password !== confirmPassword) {
      group.controls.confirmPassword.setErrors({
        ...group.controls.confirmPassword.errors,
        confirmPassword: true
      });
    } else if (password === confirmPassword && group.controls.confirmPassword.hasError('confirmPassword')) {
      delete group.controls.confirmPassword.errors.match;
      group.controls.confirmPassword.updateValueAndValidity();
    }
  }

  update() {
    if (this.passwordForm.valid) {
      Alert.question(Alert.getMessage().question.update)
        .then((response) => {
          if (response.value) {
            this.spinner.show();
            this.subscription.add(
              this.userService.changePassword({
                id: this.queryParams.id,
                password: this.passwordForm.value.password,
              }).subscribe(
                () => Alert.success(Alert.getMessage().success.user.changePassword)
                  .then(() => this.router.navigate(['/user/add'], { queryParams: { id: this.queryParams.id } })),
                () => Alert.error(Alert.getMessage().errors.user.changePassword)
              )
            );
            this.spinner.hide();
          }
        });
    } else {
      this.passwordForm.markAllAsTouched();
    }
  }

}
